import Vue from "vue";
import TimeSlotsView from "../appointments/components/TimeSlotsView.vue";
import $ from "jquery";
import moment from "moment";
import _ from "underscore";

document.addEventListener("DOMContentLoaded", (_) => {
  const bus = new Vue();

  var props = {
    bus: bus,
    onChoose: function (slots) {
      var form = $("form#choose-provider");
      $("#appointment_type", form).val($(".js-appointment-type:checked").val());
      $("#slots", form).val(JSON.stringify(slots));
      form[0].submit();
    },

    loadData: function (viewComponent) {
      var data = {
        provider_filter: {
          appointment_type: $(".js-appointment-type:checked").val(),
        },
      };

      var location = $(".js-location").val();
      if (location !== "") data.provider_filter.location_id = location;

      var speciality = $(".js-speciality").val();
      if (speciality !== "") data.provider_filter.speciality = speciality;

      var gender = $(".js-gender:checked").val();
      if (gender !== "") data.provider_filter.gender = gender;

      var staff_profile_id = $(".js-staff-profile-id").val();
      if (staff_profile_id && staff_profile_id !== "") data.provider_filter.staff_profile_id = staff_profile_id;
      $("#specialities-filter").toggle(staff_profile_id === "");
      $("#gender-filter").toggle(staff_profile_id === "");

      var service = $(".js-services").val();
      if (service && service !== "") data.provider_filter.service = service;

      if ($(".js-accepts-new-patients").is(":checked")) data.provider_filter.accepts_new_patients = true;

      return data;
    },
  };

  // Form fields
  bus.$on("mounted", (viewComponent) => {
    $(".js-staff-profile-id")
      .chosen()
      .change((_) => loadLocations(viewComponent));
    $(".js-speciality").chosen().change(viewComponent.reload);
    $(".js-location").chosen().change(viewComponent.reload);
    $(".js-services").chosen().change(viewComponent.reload);
    $(".js-gender").on("change", viewComponent.reload);
    $(".js-accepts-new-patients").on("change", viewComponent.reload);
  });

  new Vue({
    el: "#available-time-slots",
    render: (h) => h(TimeSlotsView, { props }),
  });

  // Advanced filters
  $("#show-advanced-filters").on("click", function (e) {
    e.preventDefault();
    $("#advanced-filters").show();
    $("#show-advanced-filters").hide();
    $("#hide-advanced-filters").show();
    setTimeout(function () {
      $(".chosen-select").chosen({ width: "100%" });
    }, 100);
  });
  $("#hide-advanced-filters").on("click", function (e) {
    e.preventDefault();
    $("#advanced-filters").hide();
    $("#show-advanced-filters").show();
    $("#hide-advanced-filters").hide();
  });

  // Calendar
  function loadLocations(viewComponent) {
    var $locations = $(".js-location");
    var location_id = $locations.val();
    var staff_profile_id = $(".js-staff-profile-id").val();
    var selectedPrevious = false;

    $.getJSON("/appointments/staff_locations", { staff_profile_id: staff_profile_id }, function (data) {
      var items = data.items || [];
      items.unshift(["Any", ""]);

      $locations.empty();
      items.forEach(function (l) {
        var opt = $("<option></option>").attr("value", l[1]).text(l[0]);
        if (String(l[1]) === location_id) {
          opt.attr("selected", "selected");
          selectedPrevious = true;
        }
        $locations.append(opt);
      });
      $locations.trigger("chosen:updated");

      // We should load available times even if location didn't change because
      // loadLocations is triggered by staff profile id change.
      viewComponent.reload();
    });
  }

  var staffOptions = $(".js-staff-profile-id option");
  var staffSelect = $(".js-staff-profile-id");

  function updateProvidersList() {
    var type = $(".js-appointment-type:checked").val();

    if (type == "") type = null;

    $(".js-appointment-type").parent().removeClass("active");
    $(".js-appointment-type." + (type == null ? "any" : type))
      .parent()
      .addClass("active");

    var selected = $(".js-staff-profile-id option:selected").val() || "";

    var selectedSomething = false;
    staffOptions.each(function (i, o) {
      var $o = $(o);
      var visible = !type || $o.data(type);
      if (visible) {
        $o.appendTo(staffSelect);
      } else {
        $o.remove();
      }

      if ($o.val() === selected && visible) {
        $o.attr("selected", "selected");
        selectedSomething = true;
      } else {
        $o.removeAttr("selected");
      }
    });

    var v = selectedSomething ? selected : "";
    $(".js-staff-profile-id").val(v).trigger("change");
    $(".js-staff-profile-id").trigger("chosen:updated");
  }

  // If we set .d-none class to advanced filter block in HTML, the widths of select-chosen will be
  // ruined. See this bug -- https://github.com/harvesthq/chosen/issues/92
  $("#advanced-filters").hide();
  $(".d-none").hide().removeClass("d-none");

  $("#dob").datetimepicker({
    useCurrent: false,
    format: "L",
    maxDate: moment().subtract(1, "days").toDate(),
  });

  updateProvidersList();
  $(".js-appointment-type").on("change", updateProvidersList);
});
